export default __webpack_public_path__ + "static/media/Rampver Online Topfold.254b3f67.png";